/**
 * Appointment Booked - Automated Messages Settings
 * Configure messages sent after an appointment is booked
 */

import { createFileRoute, useParams } from '@tanstack/react-router'
import { Helmet } from 'react-helmet-async'
import { SettingsPageHeader } from '@/components/ui'
import { BusinessSetupPageShell } from './business-setup/components/business-setup-page-shell'
import { AppointmentBookedTimeline } from './automated-messages/components/appointment-booked-timeline'
import { formatDocumentTitle } from '@/lib/document-title'

export const Route = createFileRoute(
  '/_auth/$orgId/settings/automated-messages/appointment-booked',
)({
  component: AppointmentBookedPage,
})

function AppointmentBookedPage() {
  const { orgId } = useParams({
    from: '/_auth/$orgId/settings/automated-messages/appointment-booked',
  })

  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Appointment Booked', 'Automated Messages')}</title>
      </Helmet>

      <BusinessSetupPageShell orgId={orgId} activePath="appointment-booked">
        <SettingsPageHeader
          title="Appointment Booked"
          description="Configure which automated messages are sent after an appointment is booked."
        />

        <div className="max-w-3xl">
          <AppointmentBookedTimeline />
        </div>
      </BusinessSetupPageShell>
    </>
  )
}
